// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32vrJ","name":"styles_name__2m09v","phone":"styles_phone__2zBEr"};